import React from 'react';
import PulseLoader from "react-spinners/PulseLoader";
import './styles.css';

export default function Loader({ text, textComp = undefined }) {

	return (
		<div className="loader-container">
			<div className="loader-content">
				<PulseLoader
					color="#004afe"
					margin={1}
					size={15}
				/>
				<div className="loader-text">{text}</div>
				
				{textComp !== undefined &&
					<div className="loader-text-comp">{textComp}</div>								
				}
			</div>
		</div>
	);
}